// round = 1;
numberOfGridItemsToShow = 3;
millisecondsPerItem = 1300;
millisecondsBetweenRounds = 2000;
score = 0;
clickedItems = [];
roundForACForm = 5;




function startNewGame() {
    numberOfGridItemsToShow = 3;
    millisecondsPerItem = 1000;
    millisecondsBetweenRounds = 500;
    setComment("")    
    score = 0;
    clickedItems = [];
    hideStartButton()
    
    
    
    setTimeout(() => {
        playRound(1, millisecondsPerItem);
    }, millisecondsBetweenRounds);
    
    
}


async function playRound(round, millisecondsPerItem) {

    const urlParams = new URLSearchParams(window.location.search);
    const leadgen = urlParams.get('leadgen');
    
    if (round == roundForACForm && leadgen == "true") {
        showACForm()
        return
    }
    
	console.log("Playing round", round);
    updateScoreBoard(round, score)
	clickedItems = [];

    setTimeout(() => {
        expectedGridItemIndices = animateSomeRandomGridItems(round, numberOfGridItemsToShow);
	    console.log("expected grid item indices", expectedGridItemIndices);

    }, millisecondsBetweenRounds);

	
	await awaitUserInput(numberOfGridItemsToShow);
	if (answersAreCorrect(expectedGridItemIndices)) {
        round += 1;
        numberOfGridItemsToShow += 0.5;
        millisecondsPerItem -= millisecondsPerItem*0.1;
        score += 10;
        playRound(round, Math.floor(numberOfGridItemsToShow), millisecondsPerItem);
    } else {
        endGame();
    }
}

function endGame() {
    console.log("game ended.")
}


